const venueConfigurationComponentLoaders = Object.freeze({
  'venue-configuration.blueprint-workspace': async () => {
    const module = await import('./blueprint-components.js');
    return module.BlueprintWorkspaceComponent;
  },
  'venue-configuration.settings-workspace': async () => {
    const module = await import('./venue-settings-workspace-component.js');
    return module.VenueSettingsWorkspaceComponent;
  },
});

export default venueConfigurationComponentLoaders;
